module.exports = __webpack_public_path__ + "static/img/yytx31.2fcadc3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx31.png
// module id = 809
// module chunks = 0